import React from 'react';
import { Heart, Check } from 'lucide-react';
export function BenefitSection() {
  return <section className="w-full bg-gradient-to-br from-blue-900 to-indigo-900 py-10 px-4 text-white" data-id="element-29">
      <div className="max-w-4xl mx-auto text-center" data-id="element-30">
        <div className="flex justify-center mb-6" data-id="element-31"></div>

        <h2 className="text-3xl font-bold text-blue-200 uppercase tracking-widest mb-8" data-id="element-32">
          BENEFICIO FINAL
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-33">
          {['Entender mejor a tu hijo', 'Ayudarlo sin frustraciones', 'Acompañarlo con confianza', 'Transformar el aprendizaje en algo positivo'].map((item, index) => <div key={index} className="flex items-center bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-34">
              <div className="bg-pink-400 rounded-full p-1 mr-4 flex-shrink-0" data-id="element-35">
                <Check className="h-6 w-6 text-white stroke-[3]" data-id="element-36" />
              </div>
              <span className="text-xl md:text-2xl font-bold text-white" data-id="element-37">
                {item}
              </span>
            </div>)}
        </div>

        <div className="inline-block bg-white text-blue-900 px-8 py-4 rounded-full shadow-2xl" data-id="element-38">
          <p className="text-2xl md:text-3xl font-black" data-id="element-39">
            Todo comienza con comprender cómo aprende.
          </p>
        </div>
      </div>
    </section>;
}